import React from "react";
import { motion } from "framer-motion";
import Integrations from "./Pages/Integration";
import Section from './hoc/Section'
const steps = [
  {
    title: "Smart Contracts",
    number: 1,
    iconBg: "#722bff",
    points: ["Secure and efficient smart contracts written in Solidity for EVM-based blockchains, tailored to your project’s requirements."],
  },
  {
    title: "API Development",
    number: 2,
    iconBg: "#722bff",
    points: [
      "Robust and scalable APIs built in multiple languages, with expertise in Node.js and NestJS.",
    ],
  },
  {
    title: "UI / UX Design",
    number: 3,
    iconBg: "#722bff",
    points: ["Engaging and user-friendly designs crafted in Figma and Adobe, focused on creating intuitive digital experiences."],
  },
  {
    title: "Web Development",
    number: 4,
    iconBg: "#722bff",
    points: ["Responsive, high-performance websites built with React, Tailwind, HTML, and CSS to bring your ideas to life."],
  },
  {
    title: "Cloud Computing",
    number: 5,
    iconBg: "#722bff",
    points: [
      "End-to-end infrastructure setup and DevOps support on AWS, Azure, and Google Cloud, ensuring security and scalability.",
    ],
  },
  {
    title: "WordPress",
    number: 6,
    iconBg: "#722bff",
    points: ["Custom WordPress websites and plugins designed for flexibility, performance, and seamless content management."],
  },
];

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.25 },
  },
};

const item = {
  hidden: { opacity: 0, x: 40 },
  show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const textVariant = {
  hidden: { opacity: 0, x: 60 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut" },
  },
};

const Services = () => (
  <section id="services" className="w-full py-2 text-white">
    <div className="absolute h-auto w-full md:opacity-80 hover:scale-90 sm:opacity-50 z-0 pointer-events-none">
      {/* <img src="https://cdn.prod.website-files.com/67dc09e7e929a3f824ab44f2/67de4474b9bcdeb60029bf55_Hero%20Background%20Image.png" alt="stars"/> */}
      </div>
    <div className="max-w-[1200px] mx-auto px-4 flex flex-col lg:flex-row items-cnter gap-16 mt-24">
      {/* ------------ Left copy ------------ */}
      <motion.div
        className="flex-1 text-center lg:text-left"
        variants={textVariant}
        initial="hidden"
        whileInView="show"
        viewport={{ amount: 0.3 }}
      >
        <h2 className="text-3xl md:text-5xl font-bold">Our Services</h2>
        <p className="text-gray-300 mt-6 text-base md:text-lg leading-relaxed max-w-[500px] mx-auto lg:mx-0">
          We provide end-to-end technology solutions that empower businesses to innovate, scale, and succeed in the digital era. From blockchain development to 
          cloud infrastructure, our team combines technical expertise with creative design to deliver results that matter.
        </p>
      </motion.div>

      {/* ------------ Right list (animated) ------------ */}
      <motion.div
  variants={container}
  initial="hidden"
  whileInView="show"
  viewport={{ amount: 0.3 }}
  className="flex-1 flex flex-col gap-8 w-full"
>
  {steps.map((step) => (
    <motion.div
      key={step.title}
      variants={item}
      className="flex gap-4 items-start"
    >
      {/* Icon circle - responsive size */}
      <div
        className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: step.iconBg }}
      >
        <p className="text-base sm:text-xl font-bold">{step.number}</p>
      </div>

      {/* Title + points */}
      <div>
        <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-1">
          {step.title}
        </h3>
        <ul className="text-gray-400 text-sm sm:text-base leading-relaxed space-y-1">
          {step.points.map((pt, i) => (
            <li key={i}>{pt}</li>
          ))}
        </ul>
      </div>
    </motion.div>
  ))}
</motion.div>
    </div>

    <Integrations/>
  </section>
);

export default Section(Services, "services");
